import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { DarkModeProvider } from './contexts/DarkModeContext'
import Navbar from './components/Navbar'
import ScrollToTop from './components/ScrollToTop'
import SeoRouteMeta from './components/SeoRouteMeta'
import Home from './pages/Home'
import About from './pages/About'
import Sessions from './pages/Works'
import Library from './pages/Library'
import LibraryItem from './pages/LibraryItem'
import Community from './pages/Community'
import Dashboard from './pages/Dashboard'
import Settings from './pages/Settings'
import AdminPanel from './pages/AdminPanel'
import TutorialDetail from './pages/TutorialDetail'
import CreationDetail from './pages/CreationDetail'
import UserProfile from './pages/UserProfile'
import NotFound from './pages/NotFound'
import Footer from './components/Footer'

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <DarkModeProvider>
          <Router basename={import.meta.env.BASE_URL}>
            <ScrollToTop />
            <SeoRouteMeta />
            <div className="site-wrapper">
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/library" element={<Library />} />
                <Route path="/library/:id" element={<LibraryItem />} />
                <Route path="/community" element={<Community />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/tutorial/:id" element={<TutorialDetail />} />
                <Route path="/creation/:id" element={<CreationDetail />} />
                <Route path="/user/:username" element={<UserProfile />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
            </div>
          </Router>
        </DarkModeProvider>
      </NotificationProvider>
    </AuthProvider>
  )
}

export default App
